import 'react-native-url-polyfill/auto';
import {createClient} from '@supabase/supabase-js';
import {processLock} from '@supabase/auth-js';
import {SUPABASE_ANON_KEY, SUPABASE_URL} from './env';
import {IS_WEB} from '../utils/platform';
import storage from './appStorage';

export const isSupabaseConfigured = Boolean(
  SUPABASE_URL?.trim?.() && SUPABASE_ANON_KEY?.trim?.(),
);

if (__DEV__) {
  console.log('[supabase] isSupabaseConfigured =', isSupabaseConfigured);
  console.log('[supabase] createClient URL =', SUPABASE_URL ?? '<empty>');
}

const storageAdapter = {
  getItem: key => storage.getItem(key),
  setItem: (key, value) => storage.setItem(key, value),
  removeItem: key => storage.removeItem(key),
};

/** @type {import('@supabase/supabase-js').SupabaseClient | null} */
export const supabase = isSupabaseConfigured
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        storage: storageAdapter,
        autoRefreshToken: true,
        persistSession: true,
        // Parse #access_token from email recovery links on web.
        detectSessionInUrl: IS_WEB,
        // Web defaults to navigator.locks — races with password update + USER_UPDATED + sync; use the
        // same in-process lock as React Native (see @supabase/auth-js processLock).
        ...(IS_WEB
          ? {
              lock: processLock,
              lockAcquireTimeout: 120000,
            }
          : {}),
      },
    })
  : null;

export {getPasswordResetRedirectUrl} from './authRedirect';
